import React from 'react'
import {Link} from 'react-router-dom'
import {Button} from "@gravity-ui/uikit";


const ProjectsPage = () => {
    return (
        <>
            <div className="page-title">Проекты Мастерской</div>

            <div className="bmm-text">
               Вы можете подать собственный проект для работы на Большой математической мастерской до 01.04.2024.<br/><br/>

                <div className={"text-center"}>
                    <Link to={"account/project/create"}><Button view={"action"} size={"xl"}>
                        Подать свой проект
                    </Button></Link>
                </div>
                <br/><br/>

                Примеры проектов прошлых лет можно посмотреть по <Link to="archive">ссылке</Link>.
            </div>
        </>
    )
}

export default ProjectsPage